import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Intercept /robots.txt and /sitemap.xml before React renders
const path = window.location.pathname;
if (path === '/robots.txt') {
  const robotsTxt = `User-agent: *
Allow: /
Crawl-delay: 1

# Disallow admin or internal paths
Disallow: /api/

# Block AI scrapers from copying content
User-agent: GPTBot
Disallow: /

User-agent: ChatGPT-User
Disallow: /

User-agent: CCBot
Disallow: /

User-agent: Google-Extended
Disallow: /

User-agent: anthropic-ai
Disallow: /

User-agent: ClaudeBot
Disallow: /

User-agent: Bytespider
Disallow: /

User-agent: Omgilibot
Disallow: /

User-agent: FacebookBot
Disallow: /

User-agent: Applebot-Extended
Disallow: /

Sitemap: https://aiwebsitepackage.com/sitemap.xml`;
  document.open('text/plain');
  document.write(robotsTxt);
  document.close();
} else if (path === '/sitemap.xml') {
  const today = new Date().toISOString().split('T')[0];
  const domain = 'https://aiwebsitepackage.com';
  const pages = [
  // Homepage
  {
    loc: '/',
    priority: '1.0',
    changefreq: 'weekly'
  },
  // Service Pages (high priority — money pages)
  {
    loc: '/services/electrician-website-dublin',
    priority: '0.9',
    changefreq: 'monthly'
  }, {
    loc: '/services/restaurant-website-dublin',
    priority: '0.9',
    changefreq: 'monthly'
  }, {
    loc: '/services/barber-website-dublin',
    priority: '0.9',
    changefreq: 'monthly'
  }, {
    loc: '/services/trades-website-dublin',
    priority: '0.9',
    changefreq: 'monthly'
  }, {
    loc: '/services/hotel-website-ireland',
    priority: '0.9',
    changefreq: 'monthly'
  },
  // Blog
  {
    loc: '/blog',
    priority: '0.8',
    changefreq: 'weekly'
  }, {
    loc: '/blog/website-cost-ireland-2026',
    priority: '0.7',
    changefreq: 'monthly'
  }, {
    loc: '/blog/website-design-dublin-small-businesses',
    priority: '0.7',
    changefreq: 'monthly'
  }, {
    loc: '/blog/electrician-website-dublin',
    priority: '0.7',
    changefreq: 'monthly'
  }, {
    loc: '/blog/restaurant-website-design-ireland',
    priority: '0.7',
    changefreq: 'monthly'
  }, {
    loc: '/blog/seo-small-businesses-ireland',
    priority: '0.7',
    changefreq: 'monthly'
  },
  // Core pages
  {
    loc: '/pricing',
    priority: '0.8',
    changefreq: 'monthly'
  }, {
    loc: '/how-it-works',
    priority: '0.7',
    changefreq: 'monthly'
  }, {
    loc: '/results',
    priority: '0.6',
    changefreq: 'monthly'
  }, {
    loc: '/included',
    priority: '0.6',
    changefreq: 'monthly'
  }, {
    loc: '/demos',
    priority: '0.6',
    changefreq: 'monthly'
  }, {
    loc: '/faq',
    priority: '0.5',
    changefreq: 'monthly'
  }, {
    loc: '/contact',
    priority: '0.6',
    changefreq: 'monthly'
  },
  // Legal (low priority)
  {
    loc: '/privacy',
    priority: '0.2',
    changefreq: 'yearly'
  }, {
    loc: '/terms',
    priority: '0.2',
    changefreq: 'yearly'
  }];
  const urls = pages.map(p => `  <url>
    <loc>${domain}${p.loc}</loc>
    <lastmod>${today}</lastmod>
    <changefreq>${p.changefreq}</changefreq>
    <priority>${p.priority}</priority>
  </url>`).join('\n');
  const sitemapXml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls}
</urlset>`;
  document.open('text/xml');
  document.write(sitemapXml);
  document.close();
} else {
  render(<App data-id="element-678" />, document.getElementById('root'));
}